import React, { useEffect, useState } from "react";

// MUI
import { Box, Modal, TextField } from "@mui/material";
import EditIcon from "../../Components/Icons/EditIcon";

// Redux
import { useDispatch, useSelector } from "react-redux";
import action from "../../Redux Store/actions";

// Files
import cssClasses from "./ChangeUnitStatus.module.css";
import Button from "../../Subcomponents/Button";
import Close from "../../Components/Icons/Close";
import {
  getAllInventoryStatusFromTable,
  UpdateLeadIdToInventory,
} from "../../Services/SustenanceService";
import DropDown from "../../Subcomponents/DropDown";
import { getUnitStatus, UpdateUnitStatus } from "../../Services/Event";
import { errorTost, infoTost, successTost } from "../../Services/Toast";
import { insertInventoryLogs } from "../../Services/AllAllotments";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
};

function ChangeUnitStatus({ open, handleClose, RespValue, unit }) {
  const dispatch = useDispatch();
  const loggedInUser = useSelector((state) => state.Auth.user);

  const [StatusList, setStatusList] = useState([]);
  const [ChangeUnitStatusDetails, setChangeUnitStatusDetails] = useState({
    UnitStatus: "",
    unitStatusString: "",
    unitStatusChangeReason: "",
    holdReason: "",
  });


  useEffect(() => {
    console.log(
      "STATUS CHANGED →",
      ChangeUnitStatusDetails.unitStatusString
    );
  }, [ChangeUnitStatusDetails.unitStatusString]);

  useEffect(() => {
    dispatch(action.activeMenu("inventory"));
    fetchStatuses();
  }, []);

  const fetchStatuses = async () => {
    const resp = await getAllInventoryStatusFromTable();
    setStatusList(resp?.data || []);
  };

  const UpdateStatus = async () => {
    if (ChangeUnitStatusDetails.unitStatusString === "Locked") {
      if (!ChangeUnitStatusDetails.holdReason) {
        errorTost("Hold reason is required");
        return;
      }

      if (
        !ChangeUnitStatusDetails.unitStatusChangeReason ||
        ChangeUnitStatusDetails.unitStatusChangeReason.trim().length < 5
      ) {
        errorTost("Reason must be at least 5 characters");
        return;
      }
    }

    const response = await getUnitStatus(unit?.unitId?.unitId);

    if (
      response?.[0]?.InventoryStatus?.inventoryStatusId ===
      ChangeUnitStatusDetails.UnitStatus
    ) {
      infoTost("Unit Status already updated!");
      return;
    }

    await UpdateUnitStatus(
      ChangeUnitStatusDetails.UnitStatus,
      unit?.unitId?.unitId
    );

    // 🧾 INVENTORY LOG
    await insertInventoryLogs({
      userId: loggedInUser?.userId,
      unitId: unit?.unitId?.unitId,
      status: ChangeUnitStatusDetails.unitStatusString,
      holdReason: ChangeUnitStatusDetails.holdReason,
      reason: ChangeUnitStatusDetails.unitStatusChangeReason,
    });

    // 🔁 CLEAR LEAD IF REQUIRED
    if (unit?.leadId) {
      await UpdateLeadIdToInventory(
        { leadId: null },
        unit?.unitId?.unitId
      );
    }

    successTost("Unit Status Updated");
    RespValue(unit);
    handleClose();
  };

  const isLocked = ChangeUnitStatusDetails.unitStatusString === "Locked";
  const disableSave =
    !ChangeUnitStatusDetails.UnitStatus ||
    (isLocked &&
      (!ChangeUnitStatusDetails.holdReason ||
        ChangeUnitStatusDetails.unitStatusChangeReason.trim().length < 5));

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") handleClose();
      }}
    >
      <Box sx={style}>
        {/* HEADER */}
        <Box className={cssClasses.headerDiv}>
          <Box className={cssClasses.flexRow}>
            <Box>
              <Box className={cssClasses.HeaderTitle}>
                Unit : {unit?.unitId?.unitNo}
              </Box>
              <Box className={cssClasses.bhkTitle}>
                {unit?.inventoryTypeId?.type}
              </Box>
            </Box>
            <Box ml="auto" onClick={handleClose} style={{ cursor: "pointer" }}>
              <Close width="1.2rem" height="1.2rem" />
            </Box>
          </Box>
        </Box>

        {/* BODY */}
        <Box px={4} py={3}>
          <Box className={cssClasses.ThirdDiv}>
            <Box className={cssClasses.InputTitle}>Unit Status</Box>
            <Box className={cssClasses.widthBox}>
              <DropDown
                placeHolder="Select"
                list={StatusList.map((s) => ({
                  label: s.status,
                  value: s.inventoryStatusId,
                }))}
                selectedValue={ChangeUnitStatusDetails.UnitStatus}
                onChangeSelect={(value) => {
                  const statusObj = StatusList.find(
                    (s) => s.inventoryStatusId === value
                  );

                  setChangeUnitStatusDetails((prev) => ({
                    ...prev,
                    UnitStatus: value,
                    unitStatusString: statusObj?.status || "",
                    holdReason: "",
                    unitStatusChangeReason: "",
                  }));
                }}
              />

            </Box>
          </Box>

          {/* LOCKED FIELDS */}
          {isLocked && (
            <Box
              sx={{
                display: "flex",
                gap: "3rem",
                alignItems: "flex-start",
                mt: 3,
              }}
            >
              <Box className={cssClasses.ThirdDiv}>
                <Box className={cssClasses.InputTitle}>
                  Hold Reason <span style={{ color: "red" }}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <DropDown
                    placeHolder="Select"
                    list={[
                      { label: "Change of Design", value: "Change of Design" },
                      { label: "Management Hold", value: "Management Hold" },
                      { label: "Leased/Preleased", value: "Leased/Preleased" },
                      { label: "Amenities", value: "Amenities" },
                      { label: "Future Sell", value: "Future Sell" },
                      { label: "Other", value: "Other" },
                    ]}
                    selectedValue={ChangeUnitStatusDetails.holdReason}
                    onChangeSelect={(value) =>
                      setChangeUnitStatusDetails((prev) => ({
                        ...prev,
                        holdReason: value,
                      }))
                    }
                  />
                </Box>
              </Box>

              <Box className={cssClasses.ThirdDiv}>
                <Box className={cssClasses.InputTitle}>
                  Reason <span style={{ color: "red" }}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter reason"
                    value={ChangeUnitStatusDetails.unitStatusChangeReason}
                    onChange={(e) =>
                      setChangeUnitStatusDetails((prev) => ({
                        ...prev,
                        unitStatusChangeReason: e.target.value,
                      }))
                    }
                  />
                </Box>
              </Box>
            </Box>
          )}
        </Box>

        {/* FOOTER */}
        <Box className={cssClasses.FooterDiv}>
          <Button btnName="Discard" clicked={handleClose} />
          <Button
            btnName="Save"
            clicked={UpdateStatus}
            disable={disableSave}
            style={{ backgroundColor: "#007FFF", color: "#FFF" }}
          />
        </Box>
      </Box>
    </Modal>
  );
}

export default ChangeUnitStatus;
